import { Box } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import { FreeboardingParagraph } from "src/components/FreeboardingParagraph";
import { useJoinState } from "src/components/join/JoinState";
import { StyledImageContainer } from "src/components/StyledImageContainer";
import TextPageComponent from "src/features/TextPageComponent";

export const Route = createFileRoute("/join/_layout/")({
  component: HomePage,
});

function HomePage() {
  const invitingUserName = useJoinState((state) => state.invitingUserName);
  const teamName = useJoinState((state) => state.teamName);
  const invitingUserHeadshotUrl = useJoinState(
    (state) => state.invitingUserHeadshotUrl,
  );
  const userCount = useJoinState((state) => state.userCount);

  return (
    <TextPageComponent
      chipText="Exclusive invite-only access to trainwell teams"
      titleText={`${invitingUserName} invited you to join ${teamName}`}
      bodyText={`Get free personalized trainer-curated plans and train together with ${invitingUserName} and ${userCount} others.`}
      customComponent={
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          paddingTop={2}
          paddingBottom={2}
        >
          <StyledImageContainer>
            <img
              src={invitingUserHeadshotUrl}
              style={{ objectFit: "cover", width: "100%", height: "100%" }}
            />
          </StyledImageContainer>
          <FreeboardingParagraph sx={{ paddingTop: 2 }}>
            invited by {invitingUserName}
          </FreeboardingParagraph>
        </Box>
      }
    />
  );
}
